var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotationCollapsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.585 9.585H20.7577L22.6727 11.5L20.7577 13.415H17.585V9.585Z",
    stroke: "#0076A8",
    strokeWidth: 1.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49995 17.5L22.9999 17.5",
    stroke: "#0076A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 19.5L22.9999 17.5L20.9999 15.5",
    stroke: "#0076A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationCollapsed);
export default __webpack_public_path__ + "static/media/annotation-collapsed.0fba613f0734df16c61168217b9920ea.svg";
export { ForwardRef as ReactComponent };